

import './scss/index.scss';


// import NavAccordion from './js/nav-accordion';
//
// document.addEventListener('DOMContentLoaded', () => {
//     // Initialize targeting your specific ul ID
//     new NavAccordion('#menu-134');
// });


import './js/header-animator';
import './js/ParallaxMasonry'

// Import the Mmenu constructor
import {mBurger} from "mburger-css";
// import Mmenu from 'mmenu-js';
//
// //
// import 'mmenu-js/dist/mmenu.css';
// import 'mburger-css/dist/mburger.css';
//
// document.addEventListener(
//     "DOMContentLoaded", () => {
//         new Mmenu( "#nav-left" );
//     }
// );